const Menu = [
    {
      id: 1,
      image: "https://th.bing.com/th/id/R.f04dd8e61406006bba6836994ece040f?rik=2IvuELMnxlUL%2fw&pid=ImgRaw&r=0",
      name: "Maggi",
      category: "Lunch",
      price: "12₹",
      description:
        "Maggi is an tasty food created from medda. it is very famous in india many indians love it beacuase it is easy to make and it is tasty and cheap too.",
    },
  
    {
      id: 2,
      image: "https://th.bing.com/th/id/R.55860c2f54e53135b65b7418a5b71348?rik=chSAWpZKVuaB4A&pid=ImgRaw&r=0",
      name: "Allu Pakoida",
      category: "Lunch",
      price: "20₹",
      description:
        "Allu Pakoida is an tasty indian food made using medda etc.. it is very tasty most of the indians eat this on rainy season ",
    },
    {
      id: 3,
      image: "https://th.bing.com/th/id/OIP.5vCMlPoE5cFzvqyn1I2vwQHaEd?rs=1&pid=ImgDetMain",
      name: "Corn",
      category: "Lunch",
      price: "10₹",
      description:
        "This is corn it's also famous in india in roadside we found some people who are selling this tasty,salty food",
    },
    {
      id: 4,
      image: "https://th.bing.com/th/id/R.87128010efac1a27aff3e07b447b8d08?rik=YtIEQric2PAhYA&pid=ImgRaw&r=0",
      name: "Pasta",
      category: "Breakfast",
      price: "50₹",
      description:
        "Pasta is an amazing food made by medda.",
    },
    {
      id: 5,
      image: "https://th.bing.com/th/id/R.d135d0cc571ce9431624cf0ced541749?rik=4Nmm8VIQMrY6ag&pid=ImgRaw&r=0",
      name: "Pizza",
      category: "Breakfast",
      price: "80₹",
      description:
        "A dish of Italian origin, consisting of a flat round base of dough baked with a topping of tomatoes and cheese, typically with added meat, fish, or vegetables:",
    },
    {
      id: 6,
      image: "https://th.bing.com/th/id/R.f00fe011f838b99ded888f091aa6c4a7?rik=KN0SE3f%2f2eZpKA&pid=ImgRaw&r=0",
      name: "Non-Veg Thali",
      category: "Dinner",
      price: "180₹",
      description:
        "This is an thali where you find non-veg delicious and tasty items. This Thali is specially made for non-veg peoples",
    },
    {
      id: 7,
      image: "https://th.bing.com/th/id/R.893dc183308abbc76e235d3deebd4ea2?rik=AFEyQadjWm7MjA&pid=ImgRaw&r=0",
      name: "Sweets",
      category: "Dinner",
      price: "60₹",
      description:
        "This is desert. After having dinner if you want some sweety taste you can try this",
    },
    {
      id: 8,
      image: "https://th.bing.com/th/id/R.0d84bd9203eecfc8f771a36808445355?rik=b8IGszmBr3yG%2bg&pid=ImgRaw&r=0",
      name: "Rajma Rice",
      category: "Lunch",
      price: "60₹",
      description:
        "Rajma (Red kidney bean) is a protein rich bean curry cooked with onions and spices, and is best served with rice hence the name Rajma Rice. But this Rajma Masala can be enjoyed with parathas also. This is my favourite … ",
    },
    {
      id: 9,
      image: "https://th.bing.com/th/id/OIP.Za740rFsOukbqfwtNMa4FwHaJQ?rs=1&pid=ImgDetMain",
      name: "samaso",
      category: "Lunch",
      price: "10₹",
      description:
        "This is one of the most tasty snacks its outer part is made by medda and in inside there is Allu and it is fried in oil. ",
    },
    {
      id: 10,
      image: "https://th.bing.com/th/id/R.adf8d4685bc24f00c1d8213eba6d9e1c?rik=gJFJ1Lw6qySfQA&pid=ImgRaw&r=0",
      name: "Burger",
      category: "Breakfast",
      price: "210₹",
      description:
        "This is burger made by two bun inside two bun there are chesse, veggese etc..",
    },
    {
      id: 11,
      image: "https://th.bing.com/th/id/OIP.aG7qW3hdlk6cb1qmIuyNtgHaE9?rs=1&pid=ImgDetMain",
      name: "MoMo",
      category: "Dinner",
      price: "100₹",
      description:
        "This is popular food in Nepal. This is made by medda inside medda there are veggy",
    },
    {
      id: 12,
      image: "https://th.bing.com/th/id/OIP.OmKYxa6SSZ1Ss5qzDwKopAHaE7?rs=1&pid=ImgDetMain",
      name: "KFC",
      category: "Dinner",
      price: "500₹",
      description:
        "It is tasty Diinner. There are chicken leg piece, and French Fryies.",
    },
    {
      id: 13,
      image: "https://th.bing.com/th/id/OIP.EeQAz93BUug4Ub4xxh9pHQHaFj?rs=1&pid=ImgDetMain",
      name: "Roti Sabji",
      category: "Dinner",
      price: "100₹",
      description:
        "Its an popular indian dice. Its is also national diice of india.",
    },
  ];
  
  export default Menu;